import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    codeProp: 'reqUserCode',
    mapProp: 'reqMap',
    name: '需求项',
    ownerIdProp: 'isrfId',
    ownerTextProp: 'isrfName',
    ownerType: 'ISRF',
    textProp: 'reqTitle',
    type: 'ISRFREQ',
}
